import React from "react";
import {
  FiUsers, FiAlertCircle, FiCheckCircle, FiAlertTriangle, FiXCircle,
} from "react-icons/fi";
import { MdSecurity } from "react-icons/md";
import { SectionHeader } from "../../../components/Shared";

const SecurityPanel = ({ d }) => {
  const sec = d.security;
  return (
    <div>
      <SectionHeader title="Security & Fire Safety" />
      <div className="fm-security-grid">
        {/* Stats */}
        <div className="fm-security-stats">
          {[
            { label: "CCTV Active",   val: `${sec.cctvActive}/${sec.cctvTotal}`, color: sec.cctvActive < sec.cctvTotal ? "#f59e0b" : "#10b981", icon: MdSecurity },
            { label: "Visitor Count", val: sec.visitorCount,                      color: "#3b82f6",                                                icon: FiUsers },
            { label: "Panic Alarms",  val: sec.panicAlarms,                       color: sec.panicAlarms > 0 ? "#ef4444" : "#10b981",             icon: FiAlertCircle },
          ].map((s, i) => (
            <div key={i} className="fm-sec-stat">
              <s.icon size={28} color={s.color} />
              <div className="fm-sec-stat-val" style={{ color: s.color }}>{s.val}</div>
              <div className="fm-sec-stat-lbl">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Fire zones */}
        <div className="fm-fire-zones">
          <div className="fm-fire-title">Fire Detection Zones</div>
          {sec.fireZones.map(z => (
            <div key={z.id} className="fm-fire-row">
              {z.status === "Normal"
                ? <FiCheckCircle size={16} color="#10b981" />
                : <FiAlertTriangle size={16} color="#f59e0b" />
              }
              <span className="fm-fire-zone">{z.zone}</span>
              <span className={`fm-badge fm-badge-${z.status.toLowerCase()}`}>{z.status}</span>
              <span className="fm-fire-test">Tested: {z.lastTest}</span>
            </div>
          ))}
        </div>

        {/* Access logs */}
        <div className="fm-access-logs">
          <div className="fm-access-title">Recent Access Control</div>
          {sec.accessLogs.map(l => (
            <div key={l.id} className={`fm-access-row ${!l.granted ? "fm-access-denied" : ""}`}>
              <div className="fm-access-icon">
                {l.granted ? <FiCheckCircle size={16} color="#10b981"/> : <FiXCircle size={16} color="#ef4444"/>}
              </div>
              <div className="fm-access-body">
                <div className="fm-access-name">{l.name} <span className="fm-access-emp">{l.empId}</span></div>
                <div className="fm-access-loc">{l.location} • <span className={l.type === "Unauthorized" ? "fm-access-unauth" : ""}>{l.type}</span></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SecurityPanel;
